import { FC } from 'react'
import { SearchDefault } from './SearchDefault'
import { SearchLight } from './SearchLight'
import { SearchLegacyProps, SearchThemes } from './types'

export const themeComponents: { [x in SearchThemes]: FC<SearchLegacyProps> } = {
  default: SearchDefault,
  light: SearchLight,
}
